'use strict';

define(['view/components/tooltip', 'utils/helpers', 'utils/underscore', 'utils/ui', 'handlebars-loader!templates/menu.html'], function (Tooltip, utils, _, UI, menuTemplate) {
    var Menu = Tooltip.extend({
        setup: function setup(list, selectedIndex, options) {
            if (!this.iconUI) {
                this.iconUI = new UI(this.el, { 'useHover': true, 'directSelect': true });

                this.toggleValueListener = this.toggleValue.bind(this);

                this.toggleOpenStateListener = this.toggleOpenState.bind(this);
                this.openTooltipListener = this.openTooltip.bind(this);
                this.closeTooltipListener = this.closeTooltip.bind(this);

                this.selectListener = this.select.bind(this);
            }

            this.reset();

            list = _.isArray(list) ? list : [];
            this.list = list;

            utils.toggleClass(this.el, 'jw-hidden', list.length < 2);

            var isMenu = list.length > 2 || list.length === 2 && options && options.toggle === false;
            var isToggle = !isMenu && list.length === 2;
            utils.toggleClass(this.el, 'jw-toggle', isToggle);
            utils.toggleClass(this.el, 'jw-button-color', !isToggle);
            this.isActive = isMenu || isToggle;

            if (isMenu) {
                utils.removeClass(this.el, 'jw-off');

                this.iconUI.on('tap', this.toggleOpenStateListener).on('over', this.openTooltipListener).on('out', this.closeTooltipListener);

                var innerHtml = menuTemplate(list);
                var elem = utils.createElement(innerHtml);
                this.addContent(elem);
                this.contentUI = new UI(this.content).on('click tap', this.selectListener);
            } else if (isToggle) {
                this.iconUI.on('click tap', this.toggleValueListener);
            }

            this.selectItem(selectedIndex);
        },
        toggleValue: function toggleValue() {
            this.trigger('toggleValue');
        },
        select: function select(evt) {
            if (evt.target.parentElement === this.content) {
                var classes = utils.classList(evt.target);
                // find the class with a name of the form 'jw-item-1'
                var item = _.find(classes, function (c) {
                    return c.indexOf('jw-item') === 0;
                });
                if (item) {
                    this.trigger('select', parseInt(item.split('-')[2]));
                    this.closeTooltipListener();
                }
            }
        },
        selectItem: function selectItem(selectedIndex) {
            if (this.content) {
                for (var i = 0; i < this.content.children.length; i++) {
                    utils.toggleClass(this.content.children[i], 'jw-active-option', selectedIndex === i);
                }
            } else {
                utils.toggleClass(this.el, 'jw-off', selectedIndex === 0);
            }
            // 如果是HDMenu,则需要在label上显示当前码率 zhangzhe 2017-03-23
            if (this.isHDMenu() && this.list && this.list.length >= 2) {
                var selectedLabel = this.list[selectedIndex].label;
                var labelElem = utils.getElementsByClassName('jw-hd-label', this.el)[0];
                labelElem.innerHTML = selectedLabel;
            }
            if (this.isCCMenu() && this.list && this.list.length >= 2 && this.list[selectedIndex]) {
                var labelElem = utils.getElementsByClassName('jw-cc-label', this.el)[0];
                labelElem.innerHTML = this.list[selectedIndex].label;
            }
            if (this.isPlayrateMenu()) {
                if (this.list[selectedIndex]) {
                    utils.getElementsByClassName('jw-playrate-label', this.el)[0].innerHTML = this.list[selectedIndex].label;
                }
            }
        },
        reset: function reset() {
            utils.addClass(this.el, 'jw-off');
            this.iconUI.off();
            if (this.contentUI) {
                this.contentUI.off().destroy();
            }
            this.removeContent();
        },
        isHDMenu: function isHDMenu() {
            return utils.hasClass(this.el, 'jw-icon-hd');
        },
        isPlayrateMenu: function isPlayrateMenu() {
            return utils.hasClass(this.el, 'jw-icon-playrate');
        },
        isCCMenu: function isCCMenu() {
            return utils.hasClass(this.el, 'jw-icon-cc');
        },
        show: function show() {
            this.el.style.display = '';
        },
        hide: function hide() {
            this.el.style.display = 'none';
        }
    });

    return Menu;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/components/menu.js
 ** module id = 193
 ** module chunks = 0
 **/